<template>
    <div class="page-setting has-bc biz-add-house">
        <modal class="alarm-orange" :display="modalStatus.toOtherPage" @modalStatus="closeModal('toOtherPage')" >
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_orange.svg" alt="">
            <h1>是否保存此頁面</h1>
            <div class="content">
                是否保存目前編輯的頁面，畫面將跳轉至{{toOtherPageInfo.type}}
            </div>
            <div class="btn-group">
                <button class="border-button" @click="closeModal('toOtherPage')">不儲存</button>
                <button class="default-button" @click="toOtherPageSave(toOtherPageInfo.linkName)">儲存</button>
            </div>
        </modal>
        <add-nick-name :noClose="true"></add-nick-name>
        <add-equips @setEquips="setNewEquips($event)"></add-equips>
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <!-- <button class="new-item-btn preview">
                    <img src="@/assets/img/icon/view_gray.svg" alt="" srcset="">
                    預覽
                </button> -->
                <button class="border-button save" :disabled="status.isDisable" @click="saveHouseNoReview">僅儲存</button>
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button publish" @click="saveHouse" :disabled="status.isDisable">儲存並上架</button>
                </div>
            </div>
        </div>
        <div class="must-fill-alarm">
            <div class="title">
                注意事項：
            </div>
            <div class="list">
                儲存房源時，廣告標題為必填；上架房源時，所有<span class="star">*</span>符號均為必填。
            </div>
        </div>  
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                廣告內容
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-add-house-type">
                    <div class="section-one">
                        <div class="house-address">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    房源地址
                                </div>
                                <span v-show="error.floorErr" class="error-with-title">{{error.floorErr}}</span>
                            </label>
                            <div class="input-arear">
                                <div class="house-address-wrap">
                                    <rent-select :class="{error: error.cityCidErr}" class="select-scroll biz" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="(county, index) in counties" :key="index" :data-id="index">
                                                {{county}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select @click.native="checkOptionRules('district', '請選擇縣市與區域')" :class="{error: error.districtCidErr}" class="select-scroll biz" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" bgColor="#fff" :setDefault="address.district.state">
                                        <ul>
                                            <li v-for="(district, index) in districts" :key="index" :data-id="district.districtCid">
                                                {{district.districtName}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select-filter @click.native="checkOptionRules('road', '請選擇縣市與區域')" :class="{error: error.roadStreetCidErr}" class="select-scroll select-road biz" refName="road" :selectMsg="address.road.msg" @getId="getSelectId" bgColor="#fff" :setDefault="address.road.state">
                                        <div class="select-filter">
                                            <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                            <input v-model="filter.road" placeholder="搜尋路段" type="text">
                                        </div>
                                        <ul>
                                            <li v-for="(road, index) in filterRoad" :key="index" :data-id="road.roadStreetCid">
                                                {{road.roadStreetName}}
                                            </li>
                                        </ul>
                                    </rent-select-filter>
                                    <div class="lane">
                                        <input type="text" v-model="insertHouse.lane" placeholder="輸入幾巷">
                                        <span>巷</span>
                                    </div>
                                    <div class="alley">
                                        <input type="text" v-model="insertHouse.alley" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入幾弄">
                                        <span>弄</span>
                                    </div>
                                    <div class="number">
                                        <input :class="{error: error.numErr}" type="text" v-model="insertHouse.number" placeholder="輸入幾號">
                                        <span>號之</span>
                                    </div>
                                    <div class="number">
                                        <input type="text"  v-model="insertHouse.dash" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入之幾">
                                    </div>
                                    <div class="floor">
                                        <input :class="{error: error.floorErr}" type="text" v-model="insertHouse.floor" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="輸入樓層">
                                        <span>樓之</span>
                                    </div>
                                    <div class="room">
                                        <input type="text" v-model="insertHouse.room">
                                    </div>
                                </div>
                            </div>
                            <div class="hide-num">
                                <rent-checkbox v-model="insertHouse.isNumberHidden" val="1" checkboxMsg="隱藏門牌" tickColor="black" bgColor="#fff" borderColor="#cacfcd" :isPropChecked="false" ></rent-checkbox>
                            </div>
                        </div>

                    </div>
                    <div class="section-two">
                        <div class="house-description">
                            <div class="house-name">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        廣告標題
                                    </div>
                                    <span v-show="error.nameErr" class="error-with-title">{{error.nameErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.nameErr}" type="text" v-model="insertHouse.name" placeholder="6-20 個字">
                                </div>
                            </div>
                            <div class="house-rent">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房屋租金
                                    </div>
                                    <span v-show="error.rentMonthlyErr" class="error-with-title">{{error.rentMonthlyErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.rentMonthlyErr}" type="text" v-model="insertHouse.rentMonthly" placeholder="請輸入金額">
                                </div>
                            </div>
                            <div class="house-intro">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源介紹
                                    </div>
                                    <span v-show="error.desErr" class="error-with-title">{{error.desErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <div class="intro-container">
                                        <pre class="pre"></pre>
                                        <textarea id="add-description" @keyup="autoGrow()"  :class="{error: error.desErr}" v-model="insertHouse.description" placeholder="50-2000 個字" ></textarea>
                                        <span class="des-count"><span class="count">{{insertHouse.description.length}}</span>/2000</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="house-setting">
                            
                            <div class="lease-type">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        出租類型
                                    </div>
                                    <span v-show="error.houseTypeErr" class="error-with-title">{{error.houseTypeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.houseTypeErr}" refName="houseType" selectMsg="請選擇出租類型" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="(house, index) in houseType" :key="index" :data-id="house.houseTypeCode">
                                                {{house.itemName}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div v-if="insertHouse.houseType == 1" class="house-pattern four-items">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源格局
                                    </div>
                                </label>
                                <div class="input-arear flex-group">
                                    <rent-select @click.native="checkOptionRules('houseType', '請選擇出租類型')" refName="bedroom" selectMsg="房" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n" :data-id="n-1">
                                                {{n-1}} 房
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select @click.native="checkOptionRules('houseType', '請選擇出租類型')"  refName="sharedRoom" selectMsg="廳" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 廳
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select @click.native="checkOptionRules('houseType', '請選擇出租類型')"  refName="bathroom" selectMsg="衛浴" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 衛浴
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select @click.native="checkOptionRules('houseType', '請選擇出租類型')"  refName="balcony" selectMsg="陽台" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 陽台
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div v-else class="house-pattern two-items">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源格局
                                    </div>
                                </label>
                                <div class="input-arear flex-group">
                                    <rent-select @click.native="checkOptionRules('houseType', '請選擇出租類型')" refName="hasBalcony" selectMsg="陽台" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                                        <ul>
                                            <li data-id="1">
                                                有陽台
                                            </li>
                                            <li data-id="0">
                                                無陽台
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select @click.native="checkOptionRules('houseType', '請選擇出租類型')" refName="hasDuplex" selectMsg="閣樓" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                                        <ul>
                                            <li data-id="1">
                                                有閣樓
                                            </li>
                                            <li data-id="0">
                                                無閣樓
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <!-- <div v-if="insertHouse.houseType == 1" class="house-pattern">
                                <label for="">房源格局</label>
                                <div class="house-pattern-wrap">
                                    <rent-select refName="bedroom" selectMsg="房" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n" :data-id="n-1">
                                                {{n-1}} 房
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select refName="sharedRoom" selectMsg="廳" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 廳
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select refName="bathroom" selectMsg="衛浴" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 衛浴
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select refName="balcony" selectMsg="陽台" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 陽台
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div v-else class="house-pattern">
                                <label for="">房源格局</label>
                                <div class="house-pattern-wrap2">
                                    <rent-select refName="hasBalcony" selectMsg="陽台" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                                        <ul>
                                            <li data-id="1">
                                                有陽台
                                            </li>
                                            <li data-id="0">
                                                無陽台
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select refName="hasDuplex" selectMsg="閣樓" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                                        <ul>
                                            <li data-id="1">
                                                有閣樓
                                            </li>
                                            <li data-id="0">
                                                無閣樓
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div> -->
                            <div class="house-type">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房屋類型
                                    </div>
                                    <span v-show="error.buildingTypeErr" class="error-with-title">{{error.buildingTypeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.buildingTypeErr}" refName="buildingType" selectMsg="請選擇房屋類型" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="(build, index) in buildingType" :key="index" :data-id="build.buildingTypeCode">
                                                {{build.itemName}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div class="house-size">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源坪數
                                    </div>
                                    <span v-show="error.sizeErr" class="error-with-title">{{error.sizeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.sizeErr}" type="number"  v-model="insertHouse.size" placeholder="輸入房源坪數">
                                </div>
                            </div>
                            <div class="house-special">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        特殊樓層
                                    </div>
                                    <span v-show="error.specialTypeErr" class="error-with-title">{{error.specialTypeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.specialTypeErr}" refName="specialType" selectMsg="請選擇特殊樓層" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                    <ul>
                                        <li v-for="(special, index) in specialType" :key="index" :data-id="special.specialTypeCode">
                                            {{special.itemName}}
                                        </li>
                                    </ul>
                                </rent-select>
                                </div>
                            </div>
                            <div class="house-size">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源總樓層
                                    </div>
                                    <span v-show="error.totalFloorErr" class="error-with-title">{{error.totalFloorErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.totalFloorErr}" type="text" v-model="insertHouse.totalFloor" placeholder="輸入總樓層">
                                </div>
                            </div>
                            <div class="house-special">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        最短租期
                                    </div>
                                    <span v-show="error.shortestPeriodErr" class="error-with-title">{{error.shortestPeriodErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.shortestPeriodErr}" refName="shortestPeriod" selectMsg="請選擇最短租期" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="(date, index) in houseConfig.shortestPeriod" :key="index" :data-id="date.code">
                                                {{date.name}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div class="is-with-landlord">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        與屋主同住
                                    </div>
                                    <span v-show="error.isWithLandlordErr" class="error-with-title">{{error.isWithLandlordErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.isWithLandlordErr}" refName="isWithLandlord" selectMsg="請選擇是否與屋主同住" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li data-id="1">
                                                是
                                            </li>
                                            <li data-id="0">
                                                否
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div class="house-special">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        繳款方式
                                    </div>
                                    <span v-show="error.payByRentPayDayErr" class="error-with-title">{{error.payByRentPayDayErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.payByRentPayDayErr}" refName="payway" selectMsg="請選擇繳款方式" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li data-id="contract">
                                                {{getPayWayWord('contract')}}
                                            </li>
                                            <li data-id="date">
                                                {{getPayWayWord('date')}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <!-- <div class="input-note" @mouseenter="tipStatus.fixedPayWay=true" @mouseleave="tipStatus.fixedPayWay=false">選擇每月固定繳租的注意事項</div>
                                    <border-tips v-if="tipStatus.fixedPayWay" msg="當選擇每月固定幾號繳租時，我們就不會幫您自動生成第一筆帳單 ( 訂金 30% 以外的 70% 帳單 )" width="424px"></border-tips> -->
                                </div>
                                <span v-if="insertHouse.payByRentPayDay" v-show="error.rentPayDayErr" class="error-with-title" style="position: absolute;right: -140px;top: 0px;font-size: 12px;color: #f05a3e;">{{error.rentPayDayErr}}</span>
                                <rent-select v-if="insertHouse.payByRentPayDay" class="select-date select-scroll biz" :class="{error: error.rentPayDayErr}" refName="date" selectMsg="請選擇日期" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                    <ul>
                                        <li v-for="n in 29" :key="n" :data-id="n">
                                            每月 {{n}} 號
                                        </li>
                                        <li :data-id="-1">
                                            每月最後一天
                                        </li>
                                    </ul>
                                </rent-select>
                            </div>
                            <div class="move-in-date">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        最快起租日
                                    </div>
                                    <span v-show="error.moveInDateErr" class="error-with-title">{{error.moveInDateErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <date-picker v-model="insertHouse.moveInDate" :class="{'active': insertHouse.moveInDate != '', error: error.moveInDateErr}" placeholder="請選擇日期" :disabled-date="notBeforeToday" value-type="format" format="YYYY-MM-DD"></date-picker>
                                    <div class="input-note" @mouseenter="tipStatus.moveInDate=true" @mouseleave="tipStatus.moveInDate=false">最快起租日是什麼？</div>
                                    <border-tips v-if="tipStatus.moveInDate" msg="最快可出租日期，如為出租中房源，可設定租約到期日之後，提供房客預先訂房。" width="424px"></border-tips>
                                </div>
                            </div>
                        </div>

                        <div class="rent-include">
                            <label class="button-font input-label">
                                <div class="title">
                                    租金包含
                                </div>
                            </label>
                            <div class="wrap">
                                <house-checkbox v-model="houseInclude" v-for="(include, index) in houseRentInclude" :key="index"  :val="include.rentCode" :checkboxMsg="include.itemName" :isPropChecked="false" ></house-checkbox>
                            </div>
                        </div>
                        <bill-charge loginType="COMPANY" @error="setBillChargeError" :includeList="insertHouse.rentIncludeList" v-model="insertHouse.billChargeMode"></bill-charge>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="house-description-title" slot="toogle-title">
                標籤
            </div>
            <div class="biz-add-house-type" slot="toogle-body">
                <div class="section-two">
                    <div class="rent-include">
                        <label class="button-font input-label">
                            <div class="title">
                                提供設備
                            </div>
                        </label>
                        <div class="wrap">
                            <div class="house-equips h-align" :class="{'odd': index%2 === 0}" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index">
                                <checkbox v-model="insertHouse.equipmentList[index].check" :msg="equip.itemName" :val="equip.equipCode" :isPropChecked="insertHouse.equipmentList[index].check"></checkbox>
                                <div class="input-arear">
                                    <span class="quantifier">個</span>
                                    <input :class="{'error': error.equipment[index]}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertHouse.equipmentList[index].count" placeholder="請輸入數量">
                                </div>
                            </div>
                            <div class="house-equips new-equips" @click="$store.dispatch('setModalStatus', {state: true, type: 'bizAddEquips'})">
                                新增設備
                            </div>
                            <!-- <house-checkbox v-model="houseEquip" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index"  :val="equip.equipCode" :checkboxMsg="equip.itemName" :isPropChecked="false" ></house-checkbox> -->
                        </div>
                    </div>
                    <div class="rent-include">
                        <label class="button-font input-label">
                            <div class="title">
                                特色標籤 ( 最多選擇 6 個 )
                            </div>
                        </label>
                        <div class="wrap">
                            <house-checkbox v-model="houseFeature" v-for="(feature, index) in houseFeatures" :key="index"  :val="feature.featureCode" :checkboxMsg="feature.itemName" :isPropChecked="false" ></house-checkbox>
                        </div>
                    </div>
                    <div class="rent-include" v-if="rulesInContract.length">
                        <label class="button-font input-label">
                            <div class="title">
                                使用規範 ( 會寫入合約內 )
                            </div>
                        </label>
                        <div class="wrap">
                            <span v-for="(item, index) in rulesInContract" :key="index">
                                {{item}}{{rulesInContract.length-1 === index?'':'、'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="house-description-title" slot="toogle-title">
                廣告圖片
            </div>
            <div class="house-description-wrap" slot="toogle-body">
                <span class="title-description">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    僅接受 jpg、png，每張不得超過 5ＭＢ，建議尺寸 300 x 400 px，內容圖限上傳十張
                </span>
                <div class="biz-add-house-description">
                    <upload-img :imgError="error.imgErr" :imgCoverError="error.imgCoverErr"></upload-img>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="house-description-title" slot="toogle-title">
                上傳影片
            </div>
            <div class="house-description-wrap" slot="toogle-body">
                <span class="title-description">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    上傳案件影片讓房客找房更方便，增加成交機率，影片時間建議不要超過兩分鐘
                </span>
                <div class="biz-add-house-description">
                    <upload-video></upload-video> 
                </div>
            </div>
        </toogle-block>
        <!-- <toogle-block>
            <div class="toogle-title policy" slot="toogle-title">
                <div class="title-group">
                    自訂合約條款
                    <word-tips-hover data="可由房源管理進入自訂合約條款新增及編輯；勾選的條款將會帶入此房源【房屋租賃電子合約書】其他約定條款中。" width="400px"></word-tips-hover>
                </div>
                <div class="group">
                    <div class="view-default">
                        <router-link :to="{ name: 'bizDefaultPolicy'}" target="_blank">
                            <img src="@/assets/img/icon/view_gray.svg" alt="">
                            預設條款
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="toogle-body" slot="toogle-body">
                <policy-checkbox v-model="housePolicyComputed" v-for="(housePolicy, index) in housePolicies" :key="index" val="1" :policyId="housePolicy.policySettingCid" :checkboxMsg="housePolicy.policySettingContent" :isPropChecked="false" ></policy-checkbox>
                <div class="unset-policy" v-if="housePolicies.length ==0">
                    尚未新增合約條款
                    <button class="new-item-btn" @click="toOtherPage('bizEditPolicy', '新增合約條款')">
                        新增合約條款
                        <img src="@/assets/img/icon/arror_right_gray.svg" alt="" srcset="">
                    </button>
                </div>
            </div>
        </toogle-block> -->
        <toogle-block>
            <div class="toogle-title contract-version" slot="toogle-title">
                <div class="title-group">
                    選擇合約版本
                    <word-tips-hover data="您可以至企業設置 > 合約版本，新增合約版本，也可以使用預設合約，企業在簽名之前仍可以選擇其他合約。" width="400px"></word-tips-hover>
                </div>
                <div class="group">
                    <button class="refresh" v-if="status.isShowReloadBtn" @click="status.reloadContractVertion++, status.isShowReloadBtn=false">
                        <img src="@/assets/img/icon/refresh.svg" alt="">
                        更新合約版本
                    </button>
                </div>
            </div>
            <div class="toogle-body" slot="toogle-body">
                <choose-contract-version v-model="insertHouse.contractVersionId" @edit="status.isShowReloadBtn=true" :reload="status.reloadContractVertion"></choose-contract-version>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                選擇分群與負責業務
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="area-and-principal">
                    <!-- <div class="no-result" v-if="groupList.length == 0">
                        尚未新增分區群組
                        <div class="new-item-btn">
                            新增分區群組
                            <img src="@/assets/img/icon/arror_right_gray.svg" alt="" srcset="">
                        </div>
                    </div> -->
                    <div class="no-auth" v-if="groupList.length == 0">
                        尚未新增分區群組
                    </div>
                    <div v-else class="select-area">
                        <div>
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    業務分群
                                </div>
                                <span v-show="error.groupIdErr" class="error-with-title">{{error.groupIdErr}}</span>
                            </label>
                            <div class="input-arear">
                                <rent-select-filter :class="{error: error.groupIdErr}" class="select-scroll biz" refName="group" selectMsg="請選擇業務分群" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                    <div class="select-filter">
                                        <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                        <input v-model="filter.group" placeholder="搜尋業務分群" type="text">
                                    </div>
                                    <ul>
                                        <li v-for="(item, index) in filterGroup" :key="index" :data-id="item.id">
                                            {{item.groupName}}
                                        </li>
                                        <div class="create-tips" @click="toOtherPage('bizAddOrganizationGroup', '建立業務分群')">
                                            建立業務分群
                                            <img src="@/assets/img/icon/arror_right_blue.svg" alt="">
                                        </div>
                                    </ul>
                                </rent-select-filter>
                            </div>
                        </div>
                        <div>
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    業務
                                </div>
                                <span v-show="error.agentCidErr" class="error-with-title">{{error.agentCidErr}}</span>
                            </label>
                            <div class="input-arear">
                                <rent-select-filter :class="{error: error.agentCidErr}" class="select-scroll biz" refName="member" selectMsg="請選擇業務" @getId="getSelectId"  bgColor="#fff" :setDefault="isAgentDefault">
                                    <div class="select-filter">
                                        <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                        <input v-model="filter.agent" placeholder="搜尋業務" type="text">
                                    </div>
                                    <ul>
                                        <li v-for="(item, index) in filterAgent" :key="index" :data-id="item.userCid">
                                            {{item.name}}
                                        </li>
                                        <div class="create-tips" @click="toOtherPage('bizAddAccount', '建立業務')">
                                            建立業務
                                            <img src="@/assets/img/icon/arror_right_blue.svg" alt="">
                                        </div>
                                    </ul>
                                </rent-select-filter>
                                <div class="input-note" @mouseenter="tipStatus.agent=true" @mouseleave="tipStatus.agent=false">業務姓名會呈現在哪裡？</div>
                                <title-tips v-if="tipStatus.agent" class="tips-agent" title="廣告頁面的聯絡人" width="424px">
                                    <div class="content" slot="content">
                                        <div class="ad-title">
                                            廣告名稱
                                        </div>
                                        <div class="rent">
                                            28,000 <span class="unit">元 / 月</span>
                                        </div>
                                        <div class="agent">
                                            <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                                            <div class="name">業務姓名</div>
                                            <div class="phone">0912345678</div>
                                            <img src="@/assets/img/icon/phone_blue.svg" alt="">
                                        </div>
                                    </div>
                                </title-tips>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                房東資訊
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="landlord-info">
                    <div class="move-in-date">
                        <label class="button-font input-label">
                            <div class="title">
                                房東
                            </div>
                        </label>
                        <div class="input-arear">
                            <select-landlord @getLandlordId="setLandlordId"></select-landlord>
                            <div class="input-note" @mouseenter="tipStatus.landlordInfo=true" @mouseleave="tipStatus.landlordInfo=false">房東資訊要用來做什麼？</div>
                            <border-tips v-if="tipStatus.landlordInfo" msg="選擇此房源所屬房東，系統將每月彙整此房東所有房源，提供收支對帳表。" width="424px"></border-tips>
                        </div>
                    </div>
                    <div class="service-fee">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                服務費 %
                            </div>
                            <span v-show="error.serviceFeeRateErr" class="error-with-title">{{error.serviceFeeRateErr}}</span>
                        </label>
                        <div class="input-arear">
                            <input type="text" :class="{error: error.serviceFeeRateErr}" v-model="insertHouse.serviceFeeRate" placeholder="請輸入服務費">
                        </div>
                    </div>
                    <upload-landlord-authorization></upload-landlord-authorization>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
import DatePicker from 'vue2-datepicker';
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import HouseCheckbox from '@/components/widge/HouseCheckbox.vue';
import PolicyCheckbox from '@/components/bussiness/widges/tools/PolicyCheckbox.vue';
import billCharge from '@/components/bussiness/mgtCategory/houseMgt/addHouse/billCharge.vue';
import uploadImg from '@/components/bussiness/mgtCategory/houseMgt/addHouse/uploadImg.vue';
import uploadVideo from '@/components/bussiness/mgtCategory/houseMgt/addHouse/uploadVideo.vue';
import selectLandlord from '@/components/bussiness/mgtCategory/houseMgt/addHouse/selectLandlord.vue';
import NewPolicy from '@/components/bussiness/widges/tools/NewPolicy.vue';
import addEquips from '@/components/bussiness/widges/modals/addEquips.vue';
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import addNickName from '@/components/bussiness/widges/modals/addNickName.vue';
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import toggleBlockGrey from '@/components/bussiness/widges/tools/toggleBlockGrey.vue';
import Radio from '@/components/bussiness/widges/input/radio.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import chooseContractVersion from '@/components/bussiness/mgtCategory/houseMgt/addHouse/chooseContractVersion.vue';
import uploadLandlordAuthorization from '@/components/bussiness/mgtCategory/houseMgt/addHouse/uploadLandlordAuthorization.vue';


import { mapGetters } from 'vuex'
import { 
    apiBizGetOrganizationGroupList,
    apiBizGetMemberByGroup
} from "@/apis/api.js"; 
const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
    data () {
        return {
            componentKey: 0,
            insertHouse: {
                "name": '',
                "cityCid": null,
                "districtCid": null,
                "roadStreetCid": null,
                "lane": '',
                "alley": '',
                "floor": '',
                "number": null,
                "dash": '',
                "room": '',
                "size": '',
                "houseType": null,
                "buildingType": null,
                "specialType": null,
                "rentMonthly": '',
                "moveInDate": '',
                "shortestPeriod": null,
                "isNumberHidden": false,
                "totalFloor": '',
                "isWithLandlord": null,
                "description": '',
                "equipmentList": [],
                "rentIncludeList": [],
                "ruleList": [],
                "groupId": null,
                "agentCid": null,
                "landlordId": null,
                "serviceFeeRate": 10,
                "rentPayDay": null,
                "payByRentPayDay": null,
                "contractVersionId": null,
                "billChargeMode": [],
                "housePatternDto": {
                    "bedroom": 0,
                    "sharedRoom": 0,
                    "bathroom": 0,
                    "balcony": 0
                },
                "roomPatternDto": {
                    "hasBalcony": false,
                    "hasDuplex": false
                },
                "editCaseHousePolicyDto": {
                    "policySettingType": 1,
                    "usePolicyDtoList": []
                },
                "editCaseDepositPolicyDto": {
                    "policySettingType": 2,
                    "usePolicyDtoList": []
                },
                "policyList": {
                    "version": null,
                    "content": null,
                }
            },
            isDefault: false,
            address: {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '請選擇路名'
                }
            },
            housePattern: false,
            roomPattern: false,
            error: {
                totalFloorErr: '',
                rentMonthlyErr: '',
                sizeErr: '',
                nameErr: '',
                desErr: '',
                numErr: '',
                floorErr: '',
                moveInDateErr: '',
                cityCidErr: '',
                districtCidErr: '',
                roadStreetCidErr: '',
                houseTypeErr: '',
                buildingTypeErr: '',
                specialTypeErr: '',
                shortestPeriodErr: '',
                isWithLandlordErr: '',
                imgErr: false,
                imgCoverErr: false,
                groupIdErr: '',
                agentCidErr: '',
                serviceFeeRateErr: '',
                rentPayDayErr: '',
                payByRentPayDayErr: '',
                equipment: [],
                billCharge: ''
            },
            modalStatus:{
                globalPolocy: false,
                toOtherPage: false
            },
            tipStatus: {
                landlordInfo: false,
                moveInDate: false,
                agent: false,
                fixedPayWay: false
            },
            filter: {
                road: null,
                group: null,
                agent: null,
            },
            groupList: [],
            agentList: [],
            isAgentDefault: false,
            status: {
                isDisable: false,
                isShowReloadBtn: false,
                reloadContractVertion: 0
            },
            // TODO 假資料
            policyVersionList:[
                {
                    title: "政策版本ㄧ",
                    check: true,
                    subVersion: [
                        {
                            contentId: 1,
                            check: true,
                            content: "1對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        },
                        {
                            contentId: 2,
                            check: true,
                            content: "2對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        },
                        {
                            contentId: 3,
                            check: true,
                            content: "3對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        },
                        {
                            contentId: 4,
                            check: true,
                            content: "4對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        }
                    ]
                },
                {
                    title: "政策版本二",
                    check: false,
                    subVersion: [
                        {
                            contentId: 5,
                            check: false,
                            content: "5對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        },
                        {
                            contentId: 6,
                            check: false,
                            content: "6對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        },
                        {
                            contentId: 7,
                            check: false,
                            content: "7對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        },
                        {
                            contentId: 8,
                            check: false,
                            content: "8對於租賃雙方(包租業對房東)共同的權利義務，包括押金上限、提前終止租約、使用租賃住宅的限制、修繕、室內裝修、租賃雙方的義務和責任、租賃住宅返還及遺留物處理等均有規範，若違反，契約條款將無效；而應約定事項，卻未記載於契約者，仍會構成契約內容。"
                        }
                    ]
                }
            ],
            toOtherPageInfo: {
                type: null,
                linkName: null
            },
            featureListCount: 0
        }
    },
    mounted () {
        this.$store.dispatch('getBizHouseDefault')  
        this.$store.dispatch('getHouseConfig')
        this.getGroupList()
        this.isNeedNickName()
        this.$analyticsBiz.logEvent('刊登房源', { screen_name: '刊登房源'})
        
        // 合約政策 api回傳資料後 => 設定預設值 array第一個
        this.insertHouse.policyList.version = 0;
    },
    watch: {
        insertHouse: {
            handler: function (newValue, oldValue) {
                let numerical = /^[0-9]*$/,
                    decimalNum = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
                // console.log(newValue.description)
                // console.log(newValue.description.length)
                // 總樓層
                if(newValue.totalFloor){
                    if( numerical.test(newValue.totalFloor) ){
                        this.error.totalFloorErr = ''
                    }else{
                        this.error.totalFloorErr = '請輸入數字'
                    }
                }
                if(newValue.agentCid){
                    this.error.agentCidErr = ''
                }
                if(newValue.groupId){
                    this.error.groupIdErr = ''
                }
                // 房租
                if(newValue.rentMonthly){
                    if( numerical.test(newValue.rentMonthly) ){
                        this.error.rentMonthlyErr = ''
                    }else{
                        this.error.rentMonthlyErr = '請輸入數字'
                    }
                }
                // 坪數
                if(newValue.size){
                    var decimal = /^[0-9]+(\.[0-9]?)?$/;
                    if(decimal.test(newValue.size)){
                        this.error.sizeErr = ''
                    }else{
                        this.error.sizeErr = '請輸入小數1位內'
                    }
                }
                if(newValue.name){
                    if(newValue.name.length < 6 ){
                        this.error.nameErr = '廣告標題需滿6個字'
                    }else if(newValue.name.length > 20){
                        this.error.nameErr = '廣告標題20字以內'
                    }else{
                        this.error.nameErr = ''
                    }
                }
                if(newValue.description.length > 2000){
                    this.error.desErr = '字數限制2000以內'
                }else if(newValue.description){
                    this.autoGrow()
                    this.error.desErr = ''
                } 
                if(newValue.houseType){
                    this.error.houseTypeErr = ''
                }
                if(newValue.buildingType){
                    this.error.buildingTypeErr = ''
                }
                if(newValue.specialType != null){
                    this.error.specialTypeErr = ''
                }
                if(newValue.cityCid){
                    this.error.cityCidErr = ''
                }
                if(newValue.districtCid){
                    this.error.districtCidErr = ''
                }
                if(newValue.roadStreetCid){
                    this.error.roadStreetCidErr = ''
                }
                if(newValue.number){
                    this.error.numErr = ''
                }
                if(newValue.floor){
                    this.error.floorErr = ''
                }
                if(newValue.moveInDate){
                    this.error.moveInDateErr = ''
                }
                if(newValue.shortestPeriod){
                    this.error.shortestPeriodErr = ''
                }
                if(newValue.isWithLandlord != null){
                    this.error.isWithLandlordErr = ''
                }
                if(newValue.payByRentPayDay != null){
                    this.error.payByRentPayDayErr = ''
                }
                if(newValue.payByRentPayDay === false || newValue.rentPayDay){
                    this.error.rentPayDayErr = ''
                }
                if(newValue.equipmentList.length){
                    newValue.equipmentList.forEach(item=>{
                        if(item.check){
                            if(item.count === null){
                                item.count = 1
                            }
                        }else{
                            item.count = null
                        }
                    })
                }
                this.$store.dispatch('setBizHouseList',newValue)
            },
            deep: true
        },
        // 合約政策
        // 'insertHouse.policyList.version': {
        //     handler: function (newVal, oldVal) {
        //         if(oldVal != null){
        //             this.policyVersionList[oldVal].check = false
        //             for(var i=0; i<this.policyVersionList[oldVal].subVersion.length; i++){
        //                 this.policyVersionList[oldVal].subVersion[i].check = false;
        //             }
        //         }
        //         this.policyVersionList[newVal].check = true
        //         this.insertHouse.policyList.content = this.policyVersionList[newVal]
        //     },
        //     immediate: true
        // },
        houseRentInclude: {
            handler: function (val) {
                this.insertHouse.rentIncludeList = val
                // console.log(val)
                for (let i = 0; i < val.length; i++) {
                    const element = val[i];
                    // console.log(element.itemName+element.check)
                    if(element.check){
                        this.removeBillCharge(element.itemName)
                    }
                }
            },
            immediate: true,
            deep: true
        },
        houseEquips: {
            handler: function (val) {
                this.insertHouse.equipmentList = val
            },
            immediate: true
        },
        houseFeatures: {
            handler: function (val) {
                this.insertHouse.featureList = val
            },
            immediate: true
        }
    },
    methods: {
        setBillChargeError: function (value){
            this.error.billCharge = value
        },
        toOtherPage: function (linkName, type) {
            this.toOtherPageInfo.type = type
            this.toOtherPageInfo.linkName = linkName
            if(this.insertHouse.name.length > 5 && this.insertHouse.name.length < 21 && this.error.nameErr == ''){
                this.modalStatus.toOtherPage = true
            }else{
                this.$router.push({name: linkName})
            }
        },
        toOtherPageSave: function (linkName){
            this.$store.dispatch('saveBizHouseNoReview', this.insertHouse)
            .then(() => {
                this.$router.push({name: linkName})
            })
        },
        setNewEquips: function (value) {
            this.insertHouse.equipmentList.push({
                check: true,
                itemName: value.name,
                count: value.count?value.count:0,
                equipCode: 0
            })
        },
        closeModal: function (type) {
            if(type == 'toOtherPage'){
                this.modalStatus.toOtherPage = false
            }
        },
        changePolicyCheckbox: function (index) {
            this.policyVersionList[index].check = true
            this.insertHouse.policyList.version = index
        },
        changePolicyRadio: function (index) {
            for(var i=0; i<this.policyVersionList[index].subVersion.length; i++){
                this.policyVersionList[index].subVersion[i].check = true;
            }
        },
        setLandlordId: function (value){
            this.insertHouse.landlordId = value
        },
        getSelectId: function (value) {
            // console.log(value)
            let targetId = event.target.dataset.id
            if( value.ref == 'houseType' ){
                this.insertHouse.houseType = targetId
                this.roomPattern = true
                this.housePattern = true
            }else if( value.ref == 'buildingType'){
                this.insertHouse.buildingType = targetId
            }else if ( value.ref == 'specialType' ){
                this.insertHouse.specialType = targetId
            }else if( value.ref == 'shortestPeriod' ){
                this.insertHouse.shortestPeriod = targetId
            }else if( value.ref == 'bedroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.bedroom = targetId
            }else if( value.ref == 'bathroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.bathroom = targetId
            }else if( value.ref == 'sharedRoom' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.sharedRoom = targetId
            }else if( value.ref == 'balcony' ){
                this.roomPattern = false
                this.housePattern = false
                this.insertHouse.housePatternDto.balcony = targetId
            }else if( value.ref == 'hasBalcony' ){
                this.roomPattern = false
                this.housePattern = false
                if( event.target.dataset.id == 1){
                    this.insertHouse.roomPatternDto.hasBalcony = true
                }else{
                    this.insertHouse.roomPatternDto.hasBalcony = false
                }
            }else if( value.ref == 'hasDuplex' ){
                this.roomPattern = false
                this.housePattern = false
                if( targetId == 1){
                    this.insertHouse.roomPatternDto.hasDuplex = true
                }else{
                    this.insertHouse.roomPatternDto.hasDuplex = false
                }
            }else if( value.ref == 'isWithLandlord' ){
                if( event.target.dataset.id == 1){
                    this.insertHouse.isWithLandlord = true
                }else{
                    this.insertHouse.isWithLandlord = false
                }
            }else if ( value.ref == 'county' ){
                //區域及縣市變為預設
                this.address.district.state = true
                this.address.road.state = true
                this.address.district.msg = '所有區域'
                this.address.road.msg = '所有路段'
                this.insertHouse.districtCid = null
                this.insertHouse.roadStreetCid = null

                this.insertHouse.cityCid = parseInt(targetId)+1
                this.$store.dispatch('getDistrict',(parseInt(targetId)+1))
            }else if ( value.ref == 'district' ){
                this.address.road.state = true
                this.address.road.msg = '所有路段'
                this.address.district.state = false

                this.insertHouse.districtCid = parseInt(targetId)
                this.$store.dispatch('getRoad',(parseInt(targetId)))
            }else if ( value.ref == 'road' ){
                this.address.road.state = false

                this.insertHouse.roadStreetCid = targetId
            }else if ( value.ref == 'group' ){
                this.insertHouse.groupId = targetId
                this.getAgentList(targetId)
                this.isAgentDefault = true
            }else if ( value.ref == 'member' ){
                this.insertHouse.agentCid = targetId
                this.isAgentDefault = false
            }else if( value.ref == 'payway'){
                if(targetId === 'date'){
                    this.insertHouse.payByRentPayDay = true
                }else if(targetId === 'contract'){
                    this.insertHouse.payByRentPayDay = false
                }
            }else if( value.ref == 'date'){
                this.insertHouse.rentPayDay = parseInt(targetId)
            }
        },
        saveHouse: function () {
            if(this.checkInput()){
                this.status.isDisable = true
                // this.insertHouse.alley = this.insertHouse.alley?this.insertHouse.alley:0
                // this.insertHouse.dash = this.insertHouse.dash?this.insertHouse.dash:0
                this.$analyticsBiz.logEvent('儲存並上架', { screen_name: '儲存並上架'})
                this.insertHouse.moveInDate = this.getFormatDate(this.insertHouse.moveInDate)
                this.$store.dispatch('setLoadingState', 1)
                this.$store.dispatch('saveBizHouse', this.insertHouse)
                .then(() => {
                    // setTimeout(()=>{
                        this.status.isDisable = false
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '新增房源成功',type: 'success'})
                        this.$router.push({ name: 'bizHouseMgtDefault'})
                        this.$store.dispatch('setLoadingState', 0)
                    // }, 3000)
                    
                })
                .catch(err => {
                    this.status.isDisable = false
                })
            }
        },
        saveHouseNoReview: function () {
            if( this.noReviewCheckInput() ){
                this.status.isDisable = true
                this.$analyticsBiz.logEvent('僅儲存', { screen_name: '僅儲存'})
                this.insertHouse.moveInDate?this.getFormatDate(this.insertHouse.moveInDate):null
                this.$store.dispatch('setLoadingState', 1)
                this.$store.dispatch('saveBizHouseNoReview', this.insertHouse)
                .then(() => {
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '新增房源成功',type: 'success'})
                    this.$router.push({ name: 'bizHouseMgtDefault'})
                    this.$store.dispatch('setLoadingState', 0)
                    this.status.isDisable = false
                })
                .catch(err => {
                    this.status.isDisable = false
                })
            }
                
        },
        getHouseDefault: function () {
            this.$store.dispatch('getBizHouseDefault')
        },
        autoGrow: function (){
            let textarea = document.getElementById('add-description')
            let adjustedHeight=textarea.clientHeight;

            adjustedHeight=Math.max(textarea.scrollHeight,adjustedHeight);
            // if (adjustedHeight>textarea.clientHeight){
                textarea.style.height=adjustedHeight+'px';
            // }

        },
        isNeedNickName: function () {
            // console.log(this.userVerify)
            // console.log(this.userNickname)
            this.$store.dispatch('getUserStatus')
            .then( () => {
                if(!this.userVerify && !this.userNickname){
                    this.$analyticsBiz.logEvent('新增出租人姓名', { screen_name: '新增出租人姓名'})
                    this.$store.dispatch('setModalStatus', {state: true, type: 'bizAddNickName'})
                }
            })
        },
        notBeforeToday(date) {
            return date < today;
        },
        noReviewCheckInput (){
            if(!this.insertHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            // if(this.insertHouse.billChargeMode.length){
            //     for (let i = 0; i < this.insertHouse.billChargeMode.length; i++) {
            //         const element = this.insertHouse.billChargeMode[i];
            //         if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
            //             this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
            //             this.error.billCharge = true
            //             return
            //         }
            //     }
            // }
            if(
                this.insertHouse.name.length > 5 &&
                this.insertHouse.name.length < 21 &&
                this.error.nameErr == '' 
                // !this.error.billCharge
            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        checkInput: function () {
            if(!this.hasImage){
                this.error.imgErr = true
            }else{
                this.error.imgErr = false
            }
            if(!this.hasCover){
                this.error.imgCoverErr = true
            }else{
                this.error.imgCoverErr = false
            }
            if(!this.insertHouse.groupId){
                this.error.groupIdErr = '請選擇分區群組'
            }
            if(!this.insertHouse.agentCid){
                this.error.agentCidErr = '請選擇負責人'
            }
            if(!this.insertHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            if(!this.insertHouse.rentMonthly){
                this.error.rentMonthlyErr = '請填寫租金'
            }

            if(!this.insertHouse.description){
                this.error.desErr = '請填寫房源描述'
            }

            if(!this.insertHouse.size){
                this.error.sizeErr = '請填寫坪數'
            }

            if(!this.insertHouse.totalFloor){
                this.error.totalFloorErr = '請填寫總樓層'
            }

            if(!this.insertHouse.number){
                this.error.numErr = '請填寫完整欄位'
            }

            if(!this.insertHouse.floor){
                this.error.floorErr = '請填寫完整欄位'
            }

            if(!this.insertHouse.moveInDate){
                this.error.moveInDateErr = '請填寫起租日'
            }
            
            if(!this.insertHouse.cityCid){
                this.error.cityCidErr = '請填寫完整欄位'
            }
            if(!this.insertHouse.districtCid){
                this.error.districtCidErr = '請填寫完整欄位'
            }
            if(!this.insertHouse.roadStreetCid){
                this.error.roadStreetCidErr = '請填寫完整欄位'
            }
            if(!this.insertHouse.houseType){
                this.error.houseTypeErr = '請選擇出租類型'
            }
            if(!this.insertHouse.buildingType){
                this.error.buildingTypeErr = '請選擇房屋類型'
            }
            if(this.insertHouse.specialType  == null){
                this.error.specialTypeErr = '請選擇特殊樓層'
            }
            if(!this.insertHouse.shortestPeriod){
                this.error.shortestPeriodErr = '請選擇最短租期'
            }
            if(this.insertHouse.payByRentPayDay == null){
                this.error.payByRentPayDayErr = '請選擇繳款方式'
            }
            if(this.insertHouse.payByRentPayDay && this.insertHouse.rentPayDay == null){
                this.error.rentPayDayErr = '請選擇繳款日'
            }
            if(this.checkEquip.isError){
                this.$store.dispatch('setAlarmStatus', {status: true,title: `提供設備：${this.checkEquip.itemName}不得為空值`,type: 'error'})
                return
            }
            if(this.insertHouse.billChargeMode.length){
                for (let i = 0; i < this.insertHouse.billChargeMode.length; i++) {
                    const element = this.insertHouse.billChargeMode[i];
                    if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
                        this.error.billCharge = true
                        return
                    }
                }
            }
            if(
                this.insertHouse.name &&
                this.insertHouse.rentMonthly &&
                this.insertHouse.description &&
                this.insertHouse.totalFloor &&
                this.insertHouse.number &&
                this.insertHouse.floor &&
                this.insertHouse.moveInDate &&
                this.insertHouse.districtCid &&
                this.insertHouse.roadStreetCid &&
                this.insertHouse.houseType &&
                this.insertHouse.buildingType &&
                this.insertHouse.cityCid &&
                this.insertHouse.isWithLandlord != null &&
                this.insertHouse.payByRentPayDay != null &&
                this.insertHouse.shortestPeriod &&
                this.insertHouse.specialType != null &&
                this.hasImage &&
                this.hasCover &&
                this.insertHouse.groupId &&
                this.insertHouse.agentCid &&
                !this.checkEquip.isError &&
                !this.error.billCharge &&
                this.error.totalFloorErr == '' &&
                this.error.rentMonthlyErr == '' &&
                this.error.sizeErr == '' &&
                this.error.nameErr == '' &&
                this.error.desErr == '' &&
                this.error.floorErr == '' &&
                this.error.moveInDateErr == '' &&
                this.error.cityCidErr == '' &&
                this.error.districtCidErr == '' &&
                this.error.roadStreetCidErr == '' &&
                this.error.houseTypeErr == '' &&
                this.error.buildingTypeErr == '' &&
                this.error.specialTypeErr == '' &&
                this.error.shortestPeriodErr == '' &&
                this.error.isWithLandlordErr == '' &&
                this.error.groupIdErr == '' &&
                this.error.agentCidErr == '' &&
                this.error.payByRentPayDayErr == '' &&
                this.error.rentPayDayErr == '' &&
                this.error.serviceFeeRateErr == ''

            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        isInRentInclude: function (itemName) {
            for (let i = 0; i < this.houseRentInclude.length; i++) {
                const element = this.houseRentInclude[i];
                if(element.check && element.itemName === itemName){
                    return true
                }
            }
        },
        closeAlart: function () {
            this.$store.commit('addHouse/set_save_success')
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        checkOptionRules: function (type, msg) {
            if(type == 'houseType'){
                if(this.insertHouse.houseType == null){
                    this.openAlarm(msg)
                }else{
                    return
                }
            }else if(type == 'road'){
                if(this.insertHouse.districtCid == null){
                    this.openAlarm(msg)
                }else{
                    return
                }
            }else if(type == 'district'){
                if(this.insertHouse.cityCid == null){
                    this.openAlarm(msg)
                }else{
                    return
                }
            }
        },
        openAlarm: function (msg) {
            let alarm = {
                status: true,
                title: msg,
                closeBtn: false,
                type: 'error'
            }
            this.$store.dispatch('setAlarmStatus', alarm)
        },
        getGroupList: function () {
            apiBizGetOrganizationGroupList()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    this.groupList =  res.data.result
                }
            })
            .catch(err => {
            })
        },
        getAgentList: function (id) {
            console.log(id)
            apiBizGetMemberByGroup(id)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.agentList =  res.data.result
                }
            })
            .catch(err => {
            })
        },
        addPercentSign: function () {
            if(this.insertHouse.serviceFeeRate != ''){
                this.insertHouse.serviceFeeRate = this.insertHouse.serviceFeeRate+' %';
            }
        },
        removePercentSign: function () {
            this.insertHouse.serviceFeeRate = this.insertHouse.serviceFeeRate.replace('%','');
            this.insertHouse.serviceFeeRate = this.insertHouse.serviceFeeRate.replace(/\s+/g,'');

            return this.insertHouse.serviceFeeRate
        },
        setFeaturesCount: function () {
            let features = this.insertHouse.featureList,
            count = 0
            features.forEach((item)=>{
                if(item.check){
                    count++
                }
            })
            this.featureListCount = count
        },
        removeBillCharge: function (itemName) {
            const list = this.insertHouse.billChargeMode
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.itemName === itemName){
                    this.insertHouse.billChargeMode.splice(i, 1)
                }
                
            }
        }
    },
    computed: {
        checkEquip: function () {
            const list = this.insertHouse.equipmentList
            let data = {
                itemName: null,
                isError: false
            }
            list.forEach((item, index) =>{
                if(item.check && !item.count){
                        data.isError = true
                        data.itemName = item.itemName
                        this.error.equipment[index] = true
                }else{
                    this.error.equipment[index] = false
                }
                this.componentKey++
            })
            return data
        },
        houseInclude:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseRentInclude.map( item => {
                    // console.log(val)
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        houseFeature:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseFeatures.map( item => {
                    if( item.itemName == val.name ){
                        if(val.value && this.featureListCount >= 6){
                            this.$store.dispatch('setAlarmStatus', {status: true,title: '特色標籤，最多選擇 6 個',type: 'error'})
                        }else{
                            if( val.value == true ){
                                item.check = true
                            }else{
                                item.check = false
                            }
                        }
                    }
                });
                this.setFeaturesCount()
            }
        },
        houseEquip:{
            get: function () {
                return // ...
            },
            set: function (val) {
                console.log(val)
                this.houseEquips.map( item => {
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        rulesInContract: function() {
            let arr = []
            let features = this.insertHouse.featureList

            for (let i = 0; i < features.length; i++) {
                const element = features[i];
                if(element.listInContract){
                    // arr[j] = element
                    if(element.listInContractWhen === 'FEATURE_NOT_SELECTED' && !element.check){
                        arr.push(element.listInContractName)
                    }else if(element.listInContractWhen === 'FEATURE_SELECTED' && element.check){
                        arr.push(element.listInContractName)
                    }
                }
            }
            return arr
        },
        housePolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.housePolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            this.insertHouse.editCaseHousePolicyDto.usePolicyDtoList.push({
                                "policySettingCid": item.policySettingCid,
                                "policyUsed": true
                            });
                        }else{
                            this.insertHouse.editCaseHousePolicyDto.usePolicyDtoList.map( (item, index) => {
                                if( item.policySettingCid == val.id){
                                    this.insertHouse.editCaseHousePolicyDto.usePolicyDtoList.splice( index, 1 )
                                }
                            })
                        }
                        
                    }
                });
            }
        },
        despositPolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.despositPolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            this.insertHouse.editCaseDepositPolicyDto.usePolicyDtoList.push({
                                "policySettingCid": item.policySettingCid,
                                "policyUsed": true
                            });
                        }else{
                            this.insertHouse.editCaseDepositPolicyDto.usePolicyDtoList.map( (item, index) => {
                                if( item.policySettingCid == val.id){
                                    this.insertHouse.editCaseDepositPolicyDto.usePolicyDtoList.splice( index, 1 )
                                }
                            })
                        }
                        
                    }
                });
            }
        },
        filterRoad: function () {
            return this.roads.filter((item) => {
                // console.log(road.roadStreetName)
                if( this.filter.road ){
                    if(item.roadStreetName.includes(this.filter.road)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterGroup: function () {
            return this.groupList.filter((item) => {
                // console.log(road.roadStreetName)
                if( this.filter.group ){
                    if(item.groupName.includes(this.filter.group)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterAgent: function () {
            return this.agentList.filter((item) => {
                // console.log(road.roadStreetName)
                if( this.filter.agent ){
                    if(item.name.includes(this.filter.agent)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            houseRules: 'GET_BIZ_RULES',
            houseEquips: 'GET_BIZ_EQUIPS',
            houseFeatures: 'GET_BIZ_FEATURES',
            houseRentInclude: 'GET_BIZ_RENT_INCLUDE',
            buildingType: 'GET_BIZ_BUILDING_TYPE',
            houseType: 'GET_BIZ_HOUSE_TYPE',
            specialType: 'GET_BIZ_SPECIAL_TYPE',
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
            housePolicies: 'GET_BIZ_HOUSE_POLICY',
            despositPolicies: 'GET_BIZ_DESPOSIT_POLICY',
            alart: 'GET_SAVE_STATE',
            hasImage: 'GET_BIZ_HOUSE_HAS_IMAGE',
            hasCover: 'GET_BIZ_HOUSE_HAS_COVER',
            userVerify: 'GET_USER_VERIFY_STATUS',
            userNickname: 'GET_USER_HAS_NICKNAME',
            houseConfig: 'GET_HOUSE_CONFIG',
        })
    },
    components: {
        DatePicker,
        RentSelect,
        RentSelectFilter,
        RentCheckbox,
        HouseCheckbox,
        uploadImg,
        PolicyCheckbox,
        Modal,
        NewPolicy,
        AlartMsg,
        addNickName,
        toogleBlock,
        selectLandlord,
        toggleBlockGrey,
        Radio,
        Checkbox,
        borderTips,
        titleTips,
        wordTipsHover,
        uploadVideo,
        btnLoading,
        addEquips,
        billCharge,
        chooseContractVersion,
        uploadLandlordAuthorization
    }
}
</script>
<style lang="scss">
    .biz-add-house{
        margin-bottom: 230px;
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .must-fill-alarm{
            position: relative;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            color: #676362;
            padding: 24px;
            .star{
                color: #fc7171;
                margin: 0 2px;
            }
            .title{
                color: #292625;
                font-weight: 500;
                margin-bottom: 14px;
            }
        }
        .select-landlord{
            width: 424px;
        }
        .title-description{
            display: flex;
            align-items: center;
            color: #676362;
            font-size: 14px;
            margin-bottom: 27px;
            img{
                margin-right: 4px;
            }
        }
        .page-header{
            .btn-group{
                .preview{
                    width: 120px;
                    margin-right: 10px;
                }
                .save{
                    width: 120px;
                    margin-right: 10px;
                }
                .publish{
                    width: 120px;
                }
                .loading-wrap{
                    position: relative;
                    .btn-loading{
                        left: -4px;
                        top: 6px;
                    }
                }
            }
        }
        // label{
        //     display: block;
        //     font-weight: 500;
        //     margin-bottom: 12px;
        // }
        // input{
        //     margin-bottom: 30px;
        // }
        .biz-rent-select{
            background: #fff;
        }
        .biz-add-house-type{
            margin-bottom: 60px;
        }
        
        .biz-add-house-type{
            .section-one{
                .house-address{
                    position: relative;
                    margin-bottom: 14px;
                    display: flex;
                    flex-wrap: wrap;
                    span.error {
                        right: 52px;
                        top: 4px;
                        left: unset;
                        bottom: unset;
                    }
                    .hide-num{
                        position: relative;
                        // top: -4px;
                        margin-left: 0px;
                        margin-bottom: 10px;
                    }
                    .house-address-wrap{
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        label{
                            margin-bottom: 0px;
                        }
                        > div{
                            margin-right: 12px;
                            margin-bottom: 16px;
                        }
                        > div:nth-child(-n+2){
                            width: 170px;
                        }
                        > div:nth-child(n+4){
                            color: #525956;
                            input{
                                width: 174px;
                                margin-bottom: 0px;
                            }
                        }
                        .select-road{
                            width: 174px;
                        }
                    }
                }
            
            }
            .section-two{
                .house-description{
                    >div{
                        margin-bottom: 30px;
                    }
                    .house-intro{
                        min-height: 100px;
                        .intro-container{
                            position: relative;
                            min-height: 84px;
                            textarea{
                                position: relative;
                                top: 0px;
                                left: 0px;
                                min-height: 84px;
                                height: 100%;
                                padding: 12px 476px 12px 16px;
                                // background: transparent;
                                outline: 0;
                                resize: none;
                                overflow: hidden;
                            }
                            .des-count{
                                position: absolute;
                                z-index: 2;
                                right: 16px;
                                bottom: 12px;
                                color: #c5c2c1;
                                .count{
                                    color: #292625;
                                }
                            }
                            // .pre{
                            //     display: block;
                            //     visibility: hidden;
                            // }
                        }
                    }
                }
                .house-setting{
                    display: flex;
                    flex-wrap: wrap;
                    > div{
                        position: relative;
                        width: 424px;
                        margin-bottom: 30px;
                    }
                    > div:nth-child(odd){
                        margin-right: 208px;
                    }
                    .house-pattern{
                        .biz-rent-select{
                            box-sizing: border-box;
                        }
                        &.two-items{
                            .biz-rent-select{
                                width: 206px;
                            }
                        }
                        &.four-items{
                            .biz-rent-select{
                                width: 98px;
                            }
                        }
                    }
                    .select-date{
                        position: absolute;
                        width: 98px;
                        top: 21px;
                        right: -142px;
                    }
                    .move-in-date{
                        .mx-datepicker{
                            width: 424px;
                            input{
                                height: 46px;
                                border-radius: 4px;
                                border: solid 1px #e0dfde;
                                color: #a8a5a4;
                                padding: 13px 16px;
                                box-shadow: none;
                                margin-bottom: 0px;
                            }
                            .mx-icon-calendar,
                            .mx-icon-clear{
                                right: 14px;
                            }
                        }
                        .mx-datepicker.error{
                            input{
                                border: solid 1px #fc7171 !important;
                            }
                        }
                        .mx-datepicker:hover{
                            input{
                                border: 1px solid #676362;
                                color: #676362;
                            }
                            i{
                                color: #676362;
                            }
                        }
                        .mx-datepicker.active{
                            input{
                                color: #676362;
                            }
                            i{
                                color: #676362;
                            }
                        }
                    }
                    
                }
                .house-equips{
                    position: relative;
                    width: 424px;
                    margin-bottom: 16px !important;
                    justify-content: space-between;
                    &.odd{
                        margin-right: 208px !important;
                    }
                    &.new-equips{
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background-color: #ffffff;
                        height: 42px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                    .input-arear{
                        width: 310px;
                        .quantifier{
                            position: absolute;
                            right: 16px;
                            top: 12px;
                        }
                    }
                }
                .rent-include,
                .equipment,
                .rules{
                    margin-bottom: 18px;
                    .wrap{
                        display: flex;
                        flex-wrap: wrap;
                        > div{
                            margin-bottom: 12px;
                            margin-right: 12px;
                        }
                    }
                }
            }
        }
        .unset-policy{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .new-item-btn{
                width: 148px;
                margin-top: 12px;
            }
        }
        .area-and-principal{
            display: flex;
            align-items: center;
            justify-content: center;
            >div{
                margin-bottom: 20px;
            }
            .no-result{
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .new-item-btn{
                    margin-top: 12px;
                }
            }
            .select-area{
                width: 100%;
                display: flex;
                // align-items: center;
                >div{
                    width: 424px;
                }
                >div:first-child{
                    margin-right: 208px;
                }
            }
            .tips-agent{
                font-size: 20px;
                font-weight: 500;
                .ad-title{
                    margin-bottom: 10px;
                }
                .rent{
                    color: #a19d9c;
                    margin-bottom: 16px;
                    .unit{
                        font-size: 14px;
                    }
                }
                .agent{
                    display: flex;
                    align-items: center;
                    .name{
                        color: #fc7171;
                        margin-left: 8px;
                        margin-right: 12px;
                    }
                    .phone{
                        margin-right: 10px;
                        color: #3a455f;
                    }
                }
            }
        }
        .service-fee{
            width: 424px;
        }
    }
    .policy{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .group{
            display: flex;
            align-items: center;
            .view-default,
            .edit{
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #676362;
                position: relative;
                right: 45px;
                a{
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
    .contract-version{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .group{
            display: flex;
            align-items: center;
            .refresh{
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                border-radius: 4px;
                background-color: #3942b5;
                width: 134px;
                height: 32px;
                font-size: 14px;
                color: #fff;
                right: 29px;
                cursor: pointer;
                >img{
                    margin-right: 6px;
                }
            }
        }
    }

    .policy-version {
        .input-radio {
            .msg {
                font-size: 16px;
                font-weight: 500;
                color: #292625;
            }
            .radio-img {
                margin-right: 12px;
            }
        }
        .input-checkbox {
            .msg {
                color: #292625;
            }
            .checkbox-img {
                margin-right: 16px;
            }
        }
    }


    .policy-version-content {
        border-bottom: 1px solid #f3f3f3;
        padding: 20px 352px 20px 0px;

        &:first-child {
            padding-top: 5px;
        }
        &:last-child {
            border: none;
        }
        
        
    }
    .landlord-info{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        // align-items: center;
        >div{
            width: 424px;
            margin-bottom: 24px;
        }
        >div:first-child{
            margin-right: 208px;
        }
    }
    // @media screen and (max-width: 1280px) {
    //     .biz-add-house{
    //         .biz-add-house-type{
    //             .section-one{
    //                 > div:nth-child(odd) {
    //                     margin-right: 162px;
    //                 }
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/addHouse/AddHouseComp.vue